import styled from 'styled-components';

export const GetDemoContainer = styled.div`
  padding: 20px;
  background: var(--white);
  border: 1px solid var(--grey-3);
  box-sizing: border-box;
  box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
  border-radius: 8px;

  .detailed-get-demo--title {
    padding: 11px 5px 0px;
    text-align: center;
  }
  ul {
    list-style: none;
    padding-inline-start: 30px;
  }
  li {
    padding-left: 10px;
    svg {
      margin: 0 10px 0 -40px;
    }
  }
  button {
    height: 48px;
    width: 100%;
    font-size: var(--font-size-16);
  }

  @media (min-width: 1199px) {
    .detailed-get-demo--ul {
      li {
        @media (max-height: 720px) {
          &:last-child {
            display: none;
          }
        }
        @media (max-height: 660px) {
          &:nth-child(2) {
            display: none;
          }
        }
        @media (max-height: 600px) {
          &:first-child {
            display: none;
          }
        }
      }
    }
  }
`;

export const GetDemoLink = styled.div`
  width: 100%;
  height: 50px;
  padding: 10px 0;
  a {
    font-family: var(--font-family-heading);
    font-weight: var(--font-weight-700);
    font-size: var(--font-size-18);
    line-height: var(--line-height-120);
    text-align: center;
    letter-spacing: var(--letter-spacing--0-01);
    color: var(--darkest);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;

    svg {
      &:first-child {
        margin-right: 10px;
      }
      &:last-child {
        margin-left: 10px;
      }
    }
  }
  &:hover {
    a {
      color: var(--darkest);
    }
    border-radius: 8px;
  }

  @media (max-width: 991px) {
    a {
      font-size: var(--font-size-16);
      white-space: nowrap;
    }
  }
`;
